import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {ScreenSizeService} from "../../../../services/screen-size-service/screen-size.service";
import {MatButtonModule} from "@angular/material/button";
import {Router, RouterLink, RouterLinkActive} from "@angular/router";
import {MatMenuModule} from "@angular/material/menu";
import {MatIcon} from "@angular/material/icon";
import {Role} from "../../../../auth/roles.enum";
import {UserService} from "../../../../auth/user-service/user.service";
import {AppMsalAuthService} from "../../../../auth/authentication-service/app-msal-auth.service";

@Component({
    selector: 'app-nav',
    imports: [
        RouterLink,
        RouterLinkActive,
        MatButtonModule,
        MatMenuModule,
        MatIcon,
    ],
    templateUrl: './nav.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './nav.component.css'
})
export class NavComponent {
  // Injectables
  screenSizeService = inject(ScreenSizeService);
  userService = inject(UserService);
  router = inject(Router);
  protected authService = inject(AppMsalAuthService);

  // Signals
  screenSize = this.screenSizeService.screenSize;
  userRole = this.userService.role;
  protected readonly Role = Role;
}

